import { useEffect } from "react"
import { useDispatch } from "react-redux"

import { getSuperTasks } from "../Actions/API/ParametersActions"
import { SuperTaskModel } from "../Models/API/SuperTaskModel"
import { MainThunkDispatch } from "../Reducers"
import { useAppState } from "./useReduxState"

export function useAppSuperTasks(appID: string): {
    value: SuperTaskModel[] | undefined
    loading: boolean
} {
    const superTasks = useAppState(state => state.api.superTasks[appID])
    const dispatch = useDispatch<MainThunkDispatch>()

    useEffect(() => {
        if (
            superTasks === undefined ||
            (superTasks.list && superTasks?.isStale && !superTasks?.isLoading)
        ) {
            dispatch(getSuperTasks(appID))
        }
    }, [dispatch, appID, superTasks, superTasks?.isStale])

    return {
        value: superTasks?.list,
        loading: superTasks?.isLoading || false
    }
}
